import { Component, OnInit, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import echarts from 'echarts';
import 'echarts/map/js/china.js';
import { mockFansAreaBasicData } from './areaBasicData';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-fans-area',
  templateUrl: './fans-area.component.html',
  styleUrls: ['./fans-area.component.less'],
})
export class FansAreaComponent implements OnInit, OnChanges {
  constructor(private el: ElementRef) {}

static NAME = 'icc-msg-social-fans-area';

  // 地图分段自适应数据大小
  range1 = 0;
  range2 = 5000;
  range3 = 10000;
  range4 = 15000;
  range5 = 20000;
  range6 = 25000;

  // 粉丝总数
  totalFansCount = 0;

  // 图谱实例
  chartIns: any;
  colorList = ['#65d0a6', '#53a3f8'];

  // 排名列表
  rankList: Array<{
    name: string; // 来自省份名称
    value: string; // 粉丝数
    ratio: string; // 占比
  }>;

  // 数据源
  @Input() data: Array<{
    item: string; // 来自省份名称
    value: number; // 粉丝数
  }>;

  chartData: any = [];

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    window.addEventListener('resize', this.resizeCharts);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data instanceof Array && this.data.length) {
      this.chartData = this.formatChartData(this.data);
      this.rankList = [];
      this.getRank();
      let maxCount = Number(this.rankList[0].value.replace(/,/g, ''));
      this.changeCountIndex(maxCount);
      setTimeout(() => {
        this.createLineChart('chart-el');
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  // 列表数据处理
  formatPieData(data) {
    const result = [];
    data.forEach((item: any) => {
      let temp: any = {};
      temp.name = item.item;
      temp.value = formatNumber(item.value);
  
      let radioBefore = this.totalFansCount===0?0:Number((item.value / this.totalFansCount).toFixed(2)) * 100;
      temp.ratio = radioBefore.toFixed(0) + '%';
      result.push(temp);
    });
    return result;
  }

  // 地图数据处理
  formatChartData(data) {
    const result = [];
    data.forEach((item: any) => {
      this.totalFansCount = this.totalFansCount + item.value;
    });
    mockFansAreaBasicData.forEach((mockItem: any) => {
      let flag = 0;
      const temp: any = {};
      data.forEach((item: any) => {
        if (mockItem.name === item.item) {
          temp.name = item.item;
          temp.value = item.value;
          flag = 1;
        }
      });
      if (flag === 0) {
        temp.name = mockItem.name;
        temp.value = mockItem.value;
      }
      result.push(temp);
    });
    return result;
  }

  // 获取粉丝数量前五名
  getRank() {
    let tempData = this.data.sort((a, b) => b.value - a.value);
    this.rankList = this.formatPieData(tempData).splice(0, 5);
  }

  // 地图数据分段
  changeCountIndex(maxFans: number) {
    // 对最大的数据做处理，以100为单位取整，向下取整
    let nearlyCount = 0;
    if (maxFans > 0 && maxFans < 100) {
      nearlyCount = Math.floor(maxFans / 10) * 10;
    } else if (maxFans > 100 && maxFans < 1000) {
      nearlyCount = Math.floor(maxFans / 100) * 100;
    } else if (maxFans > 1000 && maxFans < 10000) {
      nearlyCount = Math.floor(maxFans / 1000) * 1000;
    } else if (maxFans > 10000 && maxFans < 100000) {
      nearlyCount = Math.floor(maxFans / 10000) * 10000;
    } else if (maxFans > 100000 && maxFans < 1000000) {
      nearlyCount = Math.floor(maxFans / 100000) * 100000;
    } else if (maxFans > 1000000 && maxFans < 10000000) {
      nearlyCount = Math.floor(maxFans / 1000000) * 1000000;
    } else if (maxFans > 10000000) {
      nearlyCount = Math.floor(maxFans / 10000000) * 10000000;
    }
    this.selfAdaptionRange(nearlyCount);
  }

  selfAdaptionRange(countIndex: number) {
    // 传入的countIndex应为5的倍数
    let oneCount = countIndex / 5;
    this.range1 = 0;
    this.range2 = oneCount;
    this.range3 = oneCount * 2;
    this.range4 = oneCount * 3;
    this.range5 = oneCount * 4;
    this.range6 = oneCount * 5;
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    this.chartIns.setOption({
      tooltip: {
        formatter(params, ticket, callback) {
          return params.seriesName + '<br />' + params.name + '：' + params.value;
        },
      },
      visualMap: {
        min: 0,
        max: 100000,
        left: 26,
        bottom: 30,
        showLabel: !0,
        pieces: [
          {
            gte: this.range6,
            // label: '大于2.5w人',
            label: `大于${this.range6}人`,
            color: '#cb2b29',
          },
          {
            gt: this.range5,
            lte: this.range6,
            // label: '2w - 2.5w人',
            label: `${this.range5} - ${this.range6}`,
            color: '#ed835a',
          },
          {
            gt: this.range4,
            lte: this.range5,
            // label: '1.5w - 2w人',
            label: `${this.range4} - ${this.range5}`,
            color: '#f1bc45',
          },
          {
            gt: this.range3,
            lte: this.range4,
            // label: '1w - 1.5w人',
            label: `${this.range3} - ${this.range4}`,
            color: '#65d0a6',
          },
          {
            gt: this.range2,
            lte: this.range3,
            // label: '5000 - 1w人',
            label: `${this.range2} - ${this.range3}`,
            color: '#78d1fa',
          },
          {
            gte: this.range1,
            lte: this.range2,
            // label: '0 - 5000人',
            label: `${this.range1} - ${this.range2}`,
            color: '#53a3f8',
          },
        ],
        show: !0,
      },
      geo: {
        map: 'china',
        roam: false,
        zoom: 1,
        label: {
          normal: {
            show: true,
            fontSize: '10',
          },
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(0, 0, 0, 0.2)',
          },
          emphasis: {
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 20,
            borderWidth: 1,
            borderColor: '#fff',
            areaColor: '#f3f4f9',
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
      series: [
        {
          zoom: 0.5,
          name: '粉丝量',
          type: 'map',
          geoIndex: 0,
          data: this.chartData,
        },
      ],
    });
  }
}
